<template>
	<header>
		<div>
			<button v-if="showBackButton" to="/" id="backButton" @click="$router.back()">Go back</button>
			<router-link to='/'><h1>Opera Network Visualisation</h1></router-link>
		</div>
	</header>
</template>

<script>
export default {
	computed: {
		showBackButton() {
			return this.$route.path != '/' && this.$route.path != '/notfound';
		},
	},
};

</script>

<style scoped>
header {
	width: 100%;
	height: 5rem;
	background-color: #642db4;
	display: flex;
	justify-content: center;
	align-items: center;
}

header div {
	width: 90%;
	margin: auto;
	display: flex;
	justify-content: center;
	align-items: center;
}

#backButton {
	position: absolute;
	left: 3rem;
	padding: 0.75rem;
	border: 2px solid white;
	border-radius: 0.75rem;
	background: white;
	color: #3d008d;
	font-weight: bold;
	font-size: medium;
}

#backButton:hover {
	box-shadow: 0 0 10px 2px white;
	cursor: pointer;
}

h1 {
	margin: 0;
	color: white;
}

a {
	text-decoration: none;
}
</style>